import validator from 'validator';
import { useEffect, useState } from 'react';

export const saveFileFromBlob = (fileBlob: Blob, fileName: string): void => {
    const fileUrl = window.URL.createObjectURL(fileBlob);
    const a = document.createElement('a');
    a.download = fileName;
    a.href = fileUrl;
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const getFileNameFromRequestHeaders = (headers: Record<string, any>): string | null => {
    // NOTICE: header format - "content-disposition: attachment; filename=\"fileName.something\""
    const contentDispositionValue = headers['content-disposition'];

    if (!contentDispositionValue) {
        return null;
    }

    const fileName = contentDispositionValue.split('filename=').pop().slice(1, -1);

    return typeof fileName === 'string' ? decodeURIComponent(fileName) : null;
};

const Redirect = (route: string, blank?: boolean) => {
    if (blank) window.open(route);
    else window.location.href = route;
};

const isFieldEmpty = (value: string) => {
    return validator.isEmpty(value);
};

const setCookie = (cname: string, cvalue: string, exdays: number) => {
    const d = new Date();
    // @ts-ignore
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

const checkCookie = () => {
    const isActive = getCookie('isActive');
    if (isActive !== '') {
        return true;
    } else {
        return false;
    }
};

const getCookie = (cname: any) => {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

const deleteCookie = (_cname: any) => {
    // const name = cname + '=';
    const coockie = document.cookie
        .split(';')
        .filter((value) => value.split('=')[0] === 'cname')[0];
};

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
};

const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
};

export const utils = {
    setCookie,
    checkCookie,
    getCookie,
    Redirect,
    isFieldEmpty,
    deleteCookie,
    useWindowDimensions,
    saveFileFromBlob,
    getFileNameFromRequestHeaders,
};
